import { render, staticRenderFns } from "./QuestionTypeTextVideo.vue?vue&type=template&id=371cf99b"
import script from "./QuestionTypeTextVideo.vue?vue&type=script&lang=js"
export * from "./QuestionTypeTextVideo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports